<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M15 3a2 2 0 0 1 2 2v10a2 2 0 1 1-4 0V5c0-1.1.9-2 2-2Zm-5 3a2 2 0 0 1 2 2v7a2 2 0 1 1-4 0V8c0-1.1.9-2 2-2ZM5 9a2 2 0 0 1 2 2v4a2 2 0 1 1-4 0v-4c0-1.1.9-2 2-2Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M15 3a2 2 0 0 1 2 2v10a2 2 0 1 1-4 0V5c0-1.1.9-2 2-2Zm1 2a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V5Zm-4 3a2 2 0 1 0-4 0v7a2 2 0 1 0 4 0V8Zm-2-1a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-3 4a2 2 0 1 0-4 0v4a2 2 0 1 0 4 0v-4Zm-2-1a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z"
    />
  </svg>
</template>
